export const baseOgqlServiceUrl = '/api/ogql/v0';
export const baseReportsV2ServiceUrl = '/api/reporting_service/v2';
export const baseEmbedServiceUrl = '/api/embed_crud_service/v2';
export const baseStoryV1ServiceUrl = '/api/stories/v1';
export const baseTemplateServiceUrl = '/api/reporting_service/v2/standardReports';
